import { FlexContainer } from 'features/common/components/FlexContainer';
import { FormInputTextProps } from 'features/common/components/Form/types';
import { StdText } from 'features/common/components/Text/Text.styles';
import { useFormContext } from 'react-hook-form';
import styles from './PunchupTextArea.module.css';

const PunchupTextArea = ({
	id,
	name,
	label,
	subtitle: _subtitle,
	isCharCt,
	required,
	disabled,
	...rest
}: FormInputTextProps) => {
	const {
		register,
		watch,
		formState: { errors, dirtyFields },
	} = useFormContext();
	const error = errors[name];
	const isFieldDirty = !disabled && !!dirtyFields[name as string];

	const watchedValue = watch(name);
	const charCount =
		isCharCt && typeof watchedValue === 'string' && watchedValue.length > 0 ? (
			<FlexContainer justifyContent="flex-end">
				<StdText>{watchedValue.length}</StdText>
			</FlexContainer>
		) : null;

	return (
		<div className={styles.container}>
			{label && (
				<label className="punchupFormLabel" htmlFor={id ?? name} data-required={required || undefined}>
					{label}
				</label>
			)}
			<textarea
				id={id ?? name}
				className={[styles.textarea, error ? styles.textareaError : isFieldDirty ? styles.textareaDirty : null]
					.filter(Boolean)
					.join(' ')}
				{...register(name)}
				disabled={disabled}
				{...rest}
			/>
			{charCount}
			{error?.message && <span className="punchupFormError">{error.message as string}</span>}
		</div>
	);
};

export { PunchupTextArea };
